import React from "react";
import VideoPlayer from "components/VideoPlayer";
import { Stack, CircularProgress } from "@mui/material";

const VideoPreview = ({ presignedUrl }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        padding: "4px",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: "divider",
        alignItems: "center",
        justifyContent: "center",
        width: 350,
        height: 250,
      }}
    >
      {presignedUrl ? (
        <Stack
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#000",
          }}
        >
          <VideoPlayer customUrl={presignedUrl} />
        </Stack>
      ) : (
        <CircularProgress color="primary" size={24} />
      )}
    </Stack>
  );
};

export default VideoPreview;
